import React, { Component } from 'react';
import { Media, Image, Col } from 'react-bootstrap';
import "./Referer.css";

class Referer extends Component {
  render() {
    return (
      <Media className="referer">
        <Media.Heading>
          <Col smHidden mdHidden lgHidden><Image className="center-block" src={this.props.image} circle role="presentation" /></Col>
        </Media.Heading>
        <Media.Left align="top">
          <Col xsHidden><Image src={this.props.image} circle role="presentation" /></Col>
        </Media.Left>
        <Media.Body>
          <blockquote>
            {this.props.children}
          </blockquote>
        </Media.Body>
      </Media>
    );
  }
}

export default Referer;


/** WEBPACK FOOTER **
 ** ./src/Start/Referer.js
 **/